module.exports = __webpack_public_path__ + "media/virtualStaging/virtualStagingFullService-c665ce63.png";